var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-touch',{staticClass:"wrapper",on:{"swiperight":_vm.swiperright}},[_c('div',{staticClass:"error"},[_c('van-nav-bar',{attrs:{"title":"开发中。。。","left-text":"应用","left-arrow":""},on:{"click-left":_vm.onClickLeft}}),_c('section',[_c('p',[_vm._v(" 页面开发中 ")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }